// src/models/fiscal/MDFe.js
export const SITUACOES_MDFE = [
  { value: 0, label: 'Rascunho', className: 'secondary' },
  { value: 1, label: 'Em processamento', className: 'info' },
  { value: 2, label: 'Autorizado', className: 'success' },
  { value: 3, label: 'Rejeitado', className: 'danger' },
  { value: 4, label: 'Cancelado', className: 'dark' },
  { value: 5, label: 'Encerrado', className: 'primary' },
];

export const UFS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
  'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

export const getSituacaoMDFe = (situacao) =>
  SITUACOES_MDFE.find((item) => item.value === Number(situacao)) || { label: 'Desconhecida', className: 'secondary' };

export const getAcoesMDFe = (situacao) => ({
  editar: [0, 3].includes(Number(situacao)),
  excluir: Number(situacao) === 0,
  consultar: [1, 2, 3, 4, 5].includes(Number(situacao)),
  cancelar: Number(situacao) === 2,
  encerrar: Number(situacao) === 2,
  incluirCondutor: Number(situacao) === 2,
  arquivos: [2, 4, 5].includes(Number(situacao)),
});

export class MDFe {
  constructor(data = {}) {
    this.filialId = data.filialId ?? 1;
    this.ufInicio = data.ufInicio ?? '';
    this.ufFim = data.ufFim ?? '';
    this.dataInicioViagem = data.dataInicioViagem ?? '';
    this.quantidadeCarga = data.quantidadeCarga ?? '';
    this.unidadeCarga = data.unidadeCarga ?? 1;
    this.produtoPredominante = data.produtoPredominante ?? '';
    this.ncmProdutoPredominante = data.ncmProdutoPredominante ?? '';
    this.informacaoContribuinte = data.informacaoContribuinte ?? '';
    this.informacaoFisco = data.informacaoFisco ?? '';
    this.notas = data.notas ?? [];
    this.municipiosCarregamento = data.municipiosCarregamento ?? [];
    this.ufsPercurso = data.ufsPercurso ?? [];
    this.veiculoTracaoId = data.veiculoTracaoId ?? '';
    this.reboqueIds = data.reboqueIds ?? [];
    this.condutorIds = data.condutorIds ?? [];
    this.seguros = data.seguros ?? [];
  }

  validar() {
    const erros = [];
    if (!this.filialId) erros.push('Informe a filial.');
    if (!this.ufInicio || !this.ufFim) erros.push('Informe as UFs inicial e final.');
    if (!this.dataInicioViagem) erros.push('Informe a data e hora de início da viagem.');
    if (!this.municipiosCarregamento.length) erros.push('Informe ao menos um município de carregamento.');
    if (!this.notas.length) erros.push('Vincule ao menos uma NF-e modelo 55 autorizada.');
    if (this.notas.some((nota) => !nota.codigoMunicipioDescarga || !nota.ufDescarga)) {
      erros.push('Informe o município de descarga de todas as NF-e.');
    }
    if (!(Number(this.quantidadeCarga) > 0)) erros.push('Informe um peso de carga maior que zero.');
    if (!this.veiculoTracaoId) erros.push('Informe o veículo de tração.');
    if (!this.condutorIds.length) erros.push('Informe ao menos um condutor.');
    if (this.seguros.some((seguro) => !seguro.seguradoraId || !seguro.numeroApolice?.trim())) {
      erros.push('Informe seguradora e número da apólice em todos os seguros.');
    }
    if (this.ufsPercurso.includes(this.ufInicio) || this.ufsPercurso.includes(this.ufFim)) {
      erros.push('O percurso não pode repetir a UF inicial ou final.');
    }
    return erros;
  }

  toPayload() {
    return {
      ...this,
      filialId: Number(this.filialId),
      quantidadeCarga: Number(this.quantidadeCarga),
      unidadeCarga: Number(this.unidadeCarga),
      veiculoTracaoId: Number(this.veiculoTracaoId),
      reboqueIds: this.reboqueIds.map(Number),
      condutorIds: this.condutorIds.map(Number),
      notas: this.notas.map(({ nota, ...item }) => ({ ...item, notaId: Number(item.notaId) })),
      seguros: this.seguros.map((item) => ({
        seguradoraId: Number(item.seguradoraId),
        responsavel: Number(item.responsavel),
        numeroApolice: item.numeroApolice,
        averbacoes: item.averbacoes.filter(Boolean),
      })),
    };
  }
}
